// extracted by css-extract-rspack-plugin
export default {"timestamp":"ReviewTitle-module__timestamp__bH0Iw","commentsCount":"ReviewTitle-module__commentsCount__G9GJR"};